import { Component } from '@angular/core';

@Component({
    selector: 'couriers',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CouriersComponent {}
